 document.addEventListener('DOMContentLoaded', () => {
  const targetPutELement = document.getElementById('MainContent');
  const buttonPdpSubmit = document.querySelector('.product-form__submit.button');
  console.log('PDP Boton', buttonPdpSubmit);
  let buttonFixed;

  if (buttonPdpSubmit) {
    function cloneButton() {
      buttonFixed = buttonPdpSubmit.cloneNode(true);
      buttonFixed.classList.add('button-fixed');
      targetPutELement.appendChild(buttonFixed);
    }

    function checkButtonVisibility() {
      const rect = buttonPdpSubmit.getBoundingClientRect();
      if (rect.bottom < 0) {
        buttonFixed.classList.add('active');
      } else {
        buttonFixed.classList.remove('active');
      }
    }

    cloneButton();

    checkButtonVisibility();

    window.addEventListener('scroll', () => {
      checkButtonVisibility();
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight
      ) {
        buttonFixed.classList.remove('active');
      }
    });

    const observerValue = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          var newValue = mutation.target.value;
          if (newValue === 'Pre-order Now') {
            var span = buttonFixed.querySelector('span');
            span.textContent = 'Pre-order Now';
          }
        }
      });
    });

    observerValue.observe(buttonPdpSubmit, { attributes: true });

    buttonFixed.addEventListener('click', () => {
      buttonPdpSubmit.click();
    });
  }
}); 


let element = document.querySelector('.product__description.rte.quick-add-hidden');
  
if (element) {
  let pElements = element.getElementsByTagName('p');

  for (let i = 0; i < pElements.length; i++) {
    if (pElements[i].innerHTML === '' || pElements[i].innerHTML === '<br data-mce-fragment="1">') {
      pElements[i].parentNode.removeChild(pElements[i]);
    }
  }
}
